import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormButton, FDN } from '@intersystems/isc-form';

@Component({
  selector: 'app-delete-tenant',
  templateUrl: './delete-tenant-dialog.component.html',
})
export class DeleteTenantDialogComponent {
  FDN: FDN = {
    name: 'Are you sure you want to leave this tenant?',
    description: `You will no longer have access to deployments of ${this.data.tenant}.`,
    sections: [
      {
        hide: true,
        fields: [],
      },
    ],
  };

  buttons: FormButton[] = [
    {
      id: 'btn-delete',
      text: 'Leave tenant',
      buttonClass: 'primary',
      type: 'submit',
      callback: () => {
        this.dialogRef.close(true);
      },
    },
    {
      id: 'btn-cancel',
      text: 'Cancel',
      buttonClass: 'secondary',
      type: 'reset',
      callback: () => this.dialogRef.close(false),
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<DeleteTenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) {}
}
